// The merges entity resolution made since the investigation was saved, waiting
// for a Sync to fold them into the saved copy (ADR-0079). Shown in the chip
// popover above the actions, so the analyst knows a Sync is worth a click.

import { Merge } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface MergedSinceSavedHintProps {
  /** Entities of the saved copy a live merge folded away; render nothing for 0. */
  count: number
}

export function MergedSinceSavedHint({ count }: MergedSinceSavedHintProps) {
  const { t } = useTranslation()
  if (count <= 0) return null
  return (
    <div
      data-slot="merged-since-saved-hint"
      className="flex items-start gap-2 border-t border-warning/30 bg-warning/10 px-3 py-2 text-2xs text-foreground"
    >
      <Merge className="mt-0.5 size-3.5 shrink-0 text-warning" />
      <p className="leading-relaxed">
        {t('investigations.graph.chip.mergedSinceSaved', { count })}
      </p>
    </div>
  )
}
